<template>
  <div class="selections-container">
    <div class="row">
      <div class="d-flex">
        <img
          src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Notre+se%CC%81lection.jpg"
          alt="Selections"
          class="img-selection pr-2"
        />
        <div class="d-flex flex-column justify-content-between align-items-start w-100 overflow-hidden">
          <span class="merriweather-bold-p16 pl-4">Notre sélection</span>

          <div class="selection-section px-4 py-3">
            <div
              v-for="selection in selections"
              :key="selection[0]"
              @click="goToSelection(selection[1])"
            >
              <div
                class="raleway-medi-p15 text-nowrap text-left item-link"
              >
                {{ selection[0] }}
              </div>
            </div>
          </div>

          <div class="align-items-center all-selections d-flex justify-content-center pt-2 pl-4 w-100 text-nowrap">
            <a href="/reservation-hotel" class="hortense-btn-primary raleway-bold-p" target="_blank">Tous nos hébergements</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'SelectionsList',
  data() {
    return {
      selections: [
        ["Nos hôtels", "/hotel-de-charme"],
        ["Nos chambres d'hôtes", "/chambres-dhotes-de-charme"],
        ["Nos maisons et villas", "/villa-de-charme"],
        ["Nos lieux insolites", "/logement-insolite-de-luxe"],
        ["Nos chalets", "/chalet"],
        ["Nos appartements", "/appartement-de-vacances"]
      ]
    }
  },
  methods: {
    goToSelection(link) {
      window.open(link, '_blank');
    }
  }
}
</script>

<style scoped>
.selections-container {
  top: 160px;
  left: 21px;
  gap: 32px;
  padding-top: 24px;
  padding-right: 32px;
  padding-bottom: 24px;
  padding-left: 32px;
  text-transform: capitalize !important;

  .img-selection {
    width: 200px;
    height: 342px;
    object-fit: cover;
  }

  .selection-section {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;

    .item-link {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .raleway-bold-16{
    font-family: 'Raleway';
    font-weight: 700;
    font-size: 16px;
  }

  @media screen and (max-width: 1400px) {
    .hortense-btn-primary {
      padding: 16px 20px;
    }
    
  }
}
</style>